(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Tables = Lfl.Tables || {};

    (function (Tables, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Tables, 'DatatableResolver')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * Helps by resolving a table, corresponding datatable and it's API from given identifiers.
         *
         * @param {string} tablePath
         *
         * @memberOf Lfl.Tables
         * @lends Lfl.Tables.DatatableResolver
         * @constructor
         */
        Lfl.Tables.DatatableResolver = function (tablePath) {
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */
            // Note - this relies on the fact that we look up by the same tablePath that was used to register the
            //      datatable. Since the method below (via jQuery) was somewhat unreliable (hence the need for
            //      datatablesInstances storage) we might have to add a mechanism to get the table api object if it
            //      can not be accessed by either of those ways. Proposal: by creating and storing the tablePath key
            //      in a data- attribute of the datatable. Therefore - if we have any path to the table, we can get
            //      the object. Implement if needed.
            //      Update: The "jQuery method" may actually be entirely fine - see: DataTables::InstancesMayBeUnnecessary
            var instance = Lfl.Tables.datatablesInstances[tablePath];
            var tableApi;

            if (typeof instance !== 'undefined') {
                tableApi = instance.api();
            } else {
                console.warn("Datatable instance not registered for path: '" + tablePath + "'. Will try " +
                    "using jQuery access.");

                if (!$.fn.DataTable.isDataTable(tablePath)) {
                    throw new Error("Datatable is not initialized for the table path: " + tablePath);
                }

                tableApi = $(tablePath).DataTable();

                if (typeof tableApi === 'undefined') {
                    throw new Error("Datatable object could not be found for the table path: " + tablePath +
                        "Make sure that you have initialized the datatable before calling this code." +
                        "(And that it will be initialized at all - we usually do not use it for empty lists.)");
                }
            }

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            this.getApi = function () {
                return tableApi;
            };

            this.getPath = function () {
                return tablePath;
            };
        };
    }(Lfl.Tables, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

